// Mock Data for Funstay Travel Website

export const themes = [
  { id: 'adventure', name: 'Adventure', icon: 'Mountain', description: 'Thrilling experiences for the bold' },
  { id: 'family', name: 'Family', icon: 'Users', description: 'Memorable moments with loved ones' },
  { id: 'couple', name: 'Couple', icon: 'Heart', description: 'Romantic escapes for two' },
  { id: 'honeymoon', name: 'Honeymoon', icon: 'Sparkles', description: 'Celebrate your new beginning' },
  { id: 'solo', name: 'Solo', icon: 'User', description: 'Discover yourself through travel' },
  { id: 'friends', name: 'Friends', icon: 'Users', description: 'Create memories with your squad' },
  { id: 'wellness', name: 'Wellness', icon: 'Leaf', description: 'Rejuvenate mind, body & soul' },
  { id: 'cultural', name: 'Cultural', icon: 'Landmark', description: 'Immerse in local traditions' }
];

export const destinations = [
  {
    id: 'bali',
    name: 'Bali, Indonesia',
    country: 'Indonesia',
    image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=800',
    heroImage: 'https://images.unsplash.com/photo-1555400038-63f5ba517a47?w=1200',
    description: 'Island of the Gods with stunning temples, rice terraces, and pristine beaches.',
    longDescription: 'Bali captivates visitors with its dramatic dances, colorful ceremonies, arts and crafts, and verdant rice terraces. The island offers everything from world-class surfing to ancient temples, vibrant nightlife to serene yoga retreats.',
    themes: ['couple', 'honeymoon', 'wellness', 'cultural'],
    minBudget: 99600,
    maxBudget: 415000,
    minDuration: 5,
    maxDuration: 14,
    highlights: ['Ubud Rice Terraces', 'Tanah Lot Temple', 'Seminyak Beach', 'Mount Batur'],
    bestTime: 'April - October',
    rating: 4.8
  },
  {
    id: 'paris',
    name: 'Paris, France',
    country: 'France',
    image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800',
    heroImage: 'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=1200',
    description: 'The City of Light, romance, art, and culinary excellence.',
    longDescription: 'Paris enchants millions with its iconic landmarks, world-renowned museums, and charming neighborhoods. From the Eiffel Tower to hidden bistros, every corner tells a story of art, history, and romance.',
    themes: ['couple', 'honeymoon', 'cultural', 'friends'],
    minBudget: 166000,
    maxBudget: 664000,
    minDuration: 4,
    maxDuration: 10,
    highlights: ['Eiffel Tower', 'Louvre Museum', 'Montmartre', 'Seine River Cruise'],
    bestTime: 'April - June, September - November',
    rating: 4.9
  },
  {
    id: 'tokyo',
    name: 'Tokyo, Japan',
    country: 'Japan',
    image: 'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=800',
    heroImage: 'https://images.unsplash.com/photo-1536098561742-ca998e48cbcc?w=1200',
    description: 'Where ancient traditions meet cutting-edge technology.',
    longDescription: 'Tokyo dazzles with its incredible blend of ultramodern and traditional. Experience serene temples, bustling markets, world-class cuisine, and the latest in technology and pop culture.',
    themes: ['solo', 'friends', 'cultural', 'family'],
    minBudget: 207500,
    maxBudget: 581000,
    minDuration: 7,
    maxDuration: 14,
    highlights: ['Shibuya Crossing', 'Senso-ji Temple', 'Mount Fuji Day Trip', 'Tsukiji Market'],
    bestTime: 'March - May, September - November',
    rating: 4.8
  },
  {
    id: 'maldives',
    name: 'Maldives',
    country: 'Maldives',
    image: 'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=800',
    heroImage: 'https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=1200',
    description: 'Paradise on Earth with overwater villas and crystal waters.',
    longDescription: 'The Maldives is the ultimate luxury escape featuring pristine white beaches, vibrant coral reefs, and iconic overwater bungalows. Perfect for those seeking complete relaxation in paradise.',
    themes: ['honeymoon', 'couple', 'wellness'],
    minBudget: 332000,
    maxBudget: 1245000,
    minDuration: 5,
    maxDuration: 10,
    highlights: ['Overwater Villas', 'Snorkeling', 'Sunset Cruises', 'Spa Treatments'],
    bestTime: 'November - April',
    rating: 4.9
  },
  {
    id: 'swiss-alps',
    name: 'Swiss Alps, Switzerland',
    country: 'Switzerland',
    image: 'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=800',
    heroImage: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200',
    description: 'Majestic mountains, pristine lakes, and charming villages.',
    longDescription: 'The Swiss Alps offer breathtaking scenery year-round. From skiing and snowboarding to hiking and paragliding, experience nature at its most magnificent.',
    themes: ['adventure', 'family', 'couple'],
    minBudget: 249000,
    maxBudget: 830000,
    minDuration: 5,
    maxDuration: 12,
    highlights: ['Matterhorn', 'Jungfrau', 'Lake Geneva', 'Glacier Express'],
    bestTime: 'June - September (Summer), December - March (Winter)',
    rating: 4.7
  },
  {
    id: 'santorini',
    name: 'Santorini, Greece',
    country: 'Greece',
    image: 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=800',
    heroImage: 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=1200',
    description: 'Iconic white villages perched on volcanic cliffs.',
    longDescription: 'Santorini mesmerizes with its dramatic caldera views, stunning sunsets, and distinctive Cycladic architecture. A dream destination for romance and relaxation.',
    themes: ['honeymoon', 'couple', 'friends'],
    minBudget: 166000,
    maxBudget: 581000,
    minDuration: 4,
    maxDuration: 8,
    highlights: ['Oia Sunset', 'Caldera Views', 'Wine Tasting', 'Black Sand Beaches'],
    bestTime: 'April - October',
    rating: 4.8
  },
  {
    id: 'costa-rica',
    name: 'Costa Rica',
    country: 'Costa Rica',
    image: 'https://images.unsplash.com/photo-1518259102261-b40117eabbc9?w=800',
    heroImage: 'https://images.unsplash.com/photo-1552733407-5d5c46c3bb3b?w=1200',
    description: 'Biodiversity hotspot with rainforests, volcanoes, and beaches.',
    longDescription: 'Costa Rica is a nature lover\'s paradise with incredible biodiversity, adventure activities, and a commitment to eco-tourism. Experience zip-lining, wildlife, and pura vida.',
    themes: ['adventure', 'family', 'solo', 'friends'],
    minBudget: 124500,
    maxBudget: 415000,
    minDuration: 7,
    maxDuration: 14,
    highlights: ['Arenal Volcano', 'Manuel Antonio', 'Zip-lining', 'Cloud Forest'],
    bestTime: 'December - April',
    rating: 4.7
  },
  {
    id: 'dubai',
    name: 'Dubai, UAE',
    country: 'UAE',
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800',
    heroImage: 'https://images.unsplash.com/photo-1518684079-3c830dcef090?w=1200',
    description: 'Futuristic skyline meets Arabian heritage.',
    longDescription: 'Dubai dazzles with its record-breaking architecture, luxury shopping, and desert adventures. Experience the future while exploring traditional souks and Arabian hospitality.',
    themes: ['family', 'friends', 'couple'],
    minBudget: 166000,
    maxBudget: 830000,
    minDuration: 4,
    maxDuration: 8,
    highlights: ['Burj Khalifa', 'Desert Safari', 'Palm Jumeirah', 'Dubai Mall'],
    bestTime: 'November - March',
    rating: 4.6
  }
];

// Enhanced packages with detailed itinerary, gallery, FAQs, etc.
export const packages = [
  {
    id: 'bali-honeymoon',
    title: 'Romantic Bali Escape',
    destination: 'bali',
    image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=800',
    themes: ['honeymoon', 'couple'],
    duration: 7,
    price: 207417,
    originalPrice: 248917,
    rating: 4.9,
    reviews: 124,
    description: 'Experience the magic of Bali with your loved one. Private villas, spa treatments, and romantic dinners await you on this unforgettable honeymoon journey through the Island of the Gods.',
    longDescription: 'Embark on the romantic journey of a lifetime in Bali, where ancient temples meet pristine beaches and lush rice terraces. This carefully curated 7-day honeymoon package offers the perfect blend of relaxation, adventure, and cultural immersion. From private villa accommodations with infinity pools to candlelit dinners overlooking the jungle, every moment is designed to celebrate your love.',
    highlights: ['Private Villa Stay', 'Couples Spa', 'Sunset Dinner', 'Ubud Tour'],
    maxGroupSize: 2,
    isGroupPackage: false,
    
    // Detailed Itinerary
    itinerary: [
      {
        day: 1,
        title: 'Arrival & Welcome',
        description: 'Arrive at Ngurah Rai International Airport where your private driver awaits. Transfer to your luxury private villa in Seminyak. Evening welcome dinner at a beachfront restaurant with traditional Balinese dance performance.',
        meals: ['Dinner'],
        accommodation: 'Private Pool Villa, Seminyak',
        image: 'https://images.unsplash.com/photo-1582719508461-905c673771fd?w=800',
        activities: ['Airport pickup', 'Villa check-in', 'Welcome dinner', 'Balinese dance show']
      },
      {
        day: 2,
        title: 'Seminyak Beach & Spa Day',
        description: 'Start your day with breakfast at the villa. Enjoy a leisurely morning at Seminyak Beach. Afternoon couples spa treatment including Balinese massage, flower bath, and body scrub. Sunset cocktails at Potato Head Beach Club.',
        meals: ['Breakfast', 'Lunch'],
        accommodation: 'Private Pool Villa, Seminyak',
        image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800',
        activities: ['Beach time', '2-hour couples spa', 'Sunset cocktails']
      },
      {
        day: 3,
        title: 'Ubud Cultural Experience',
        description: 'Transfer to Ubud, the cultural heart of Bali. Visit Tegallalang Rice Terraces for stunning photos. Explore Ubud Monkey Forest and Art Market. Check into your jungle villa with valley views. Romantic dinner overlooking the Ayung River.',
        meals: ['Breakfast', 'Dinner'],
        accommodation: 'Jungle Villa, Ubud',
        image: 'https://images.unsplash.com/photo-1555400038-63f5ba517a47?w=800',
        activities: ['Tegallalang Rice Terraces', 'Monkey Forest', 'Art Market', 'Romantic dinner']
      },
      {
        day: 4,
        title: 'Temple Tour & Cooking Class',
        description: 'Morning visit to the sacred Tirta Empul Temple for a purification ceremony. Afternoon Balinese cooking class at a local home - learn to prepare authentic dishes together. Evening at leisure to enjoy your private villa.',
        meals: ['Breakfast', 'Lunch'],
        accommodation: 'Jungle Villa, Ubud',
        image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=800',
        activities: ['Tirta Empul Temple', 'Purification ceremony', 'Cooking class']
      },
      {
        day: 5,
        title: 'Mount Batur Sunrise Trek',
        description: 'Early morning trek to Mount Batur to witness a breathtaking sunrise above the clouds. Breakfast with volcanic views. Return to villa for rest. Afternoon yoga session for couples. Evening romantic dinner at your villa.',
        meals: ['Breakfast', 'Dinner'],
        accommodation: 'Jungle Villa, Ubud',
        image: 'https://images.unsplash.com/photo-1504198266287-1659872e6590?w=800',
        activities: ['Sunrise trek', 'Couples yoga', 'Private villa dinner']
      },
      {
        day: 6,
        title: 'Nusa Penida Day Trip',
        description: 'Day trip to Nusa Penida island. Visit the iconic Kelingking Beach (T-Rex cliff), Crystal Bay for snorkeling, and Broken Beach. Private picnic lunch with ocean views. Return to Ubud for your final evening.',
        meals: ['Breakfast', 'Lunch'],
        accommodation: 'Jungle Villa, Ubud',
        image: 'https://images.unsplash.com/photo-1570789210967-2cac24f04879?w=800',
        activities: ['Kelingking Beach', 'Snorkeling', 'Broken Beach', 'Private picnic']
      },
      {
        day: 7,
        title: 'Departure',
        description: 'Leisurely breakfast at your villa. Optional morning visit to Ubud Palace or free time for last-minute shopping. Private transfer to the airport for your departure. Farewell gift from Funstay.',
        meals: ['Breakfast'],
        accommodation: null,
        image: 'https://images.unsplash.com/photo-1539367628448-4bc5c9d171c8?w=800',
        activities: ['Breakfast', 'Optional Ubud Palace visit', 'Airport transfer']
      }
    ],
    
    // Gallery
    gallery: [
      { url: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=800', caption: 'Tegallalang Rice Terraces' },
      { url: 'https://images.unsplash.com/photo-1555400038-63f5ba517a47?w=800', caption: 'Bali Temple' },
      { url: 'https://images.unsplash.com/photo-1582719508461-905c673771fd?w=800', caption: 'Private Pool Villa' },
      { url: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800', caption: 'Couples Spa' },
      { url: 'https://images.unsplash.com/photo-1570789210967-2cac24f04879?w=800', caption: 'Nusa Penida' },
      { url: 'https://images.unsplash.com/photo-1504198266287-1659872e6590?w=800', caption: 'Mount Batur Sunrise' },
      { url: 'https://images.unsplash.com/photo-1539367628448-4bc5c9d171c8?w=800', caption: 'Balinese Culture' },
      { url: 'https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?w=800', caption: 'Romantic Dinner' }
    ],
    
    // Inclusions
    inclusions: [
      'Return airport transfers in private air-conditioned vehicle',
      '3 nights accommodation in Private Pool Villa, Seminyak',
      '3 nights accommodation in Jungle Villa, Ubud',
      'Daily breakfast at villa or hotel',
      '2-hour couples spa treatment with flower bath',
      'Romantic beachfront welcome dinner',
      'Tegallalang Rice Terraces tour with guide',
      'Ubud Monkey Forest entrance fee',
      'Tirta Empul Temple visit with sarong',
      'Authentic Balinese cooking class',
      'Mount Batur sunrise trek with breakfast',
      'Couples yoga session',
      'Nusa Penida day trip with speedboat transfers',
      'Snorkeling equipment',
      'Private picnic lunch on Nusa Penida',
      'Romantic candlelit dinner (2 occasions)',
      'English-speaking guide throughout',
      '24/7 concierge support'
    ],
    
    // Exclusions
    exclusions: [
      'International flights to/from Bali',
      'Travel insurance (strongly recommended)',
      'Visa fees (if applicable)',
      'Personal expenses and shopping',
      'Meals not mentioned in the itinerary',
      'Alcoholic beverages',
      'Tips and gratuities for guides and drivers',
      'Optional activities not listed',
      'Camera/drone fees at temples',
      'Laundry services'
    ],
    
    // Terms & Conditions
    termsAndConditions: [
      'Booking requires a 30% non-refundable deposit',
      'Full payment is due 45 days before departure',
      'Cancellation 30+ days before: 70% refund (excluding deposit)',
      'Cancellation 15-29 days before: 50% refund',
      'Cancellation less than 15 days: No refund',
      'Changes to booking may incur additional charges',
      'Prices are per person based on double occupancy',
      'Single supplement available at additional cost',
      'Itinerary may be modified due to weather or safety concerns',
      'Valid passport required with 6+ months validity',
      'Travel insurance is mandatory but not included',
      'Minimum age requirement: 18 years',
      'Funstay reserves the right to cancel trips due to force majeure'
    ],
    
    // FAQs
    faqs: [
      {
        question: 'What is the best time to visit Bali for a honeymoon?',
        answer: 'The best time for a Bali honeymoon is during the dry season from April to October. The weather is sunny with minimal rainfall, perfect for beach activities and outdoor excursions. May-June and September are particularly pleasant with fewer tourists.'
      },
      {
        question: 'Is the Mount Batur trek difficult?',
        answer: 'The Mount Batur sunrise trek is moderate difficulty, taking about 2 hours to reach the summit. No technical climbing is required, but a reasonable fitness level is recommended. We provide flashlights, jackets, and an experienced guide. The stunning sunrise views make it absolutely worth the effort!'
      },
      {
        question: 'Can dietary requirements be accommodated?',
        answer: 'Absolutely! Bali is very accommodating for various dietary needs including vegetarian, vegan, gluten-free, and halal options. Please inform us of any requirements when booking, and we\'ll ensure all restaurants and cooking classes cater to your needs.'
      },
      {
        question: 'What should we pack for this trip?',
        answer: 'Pack light, breathable clothing, comfortable walking shoes for temple visits and trekking, swimwear, sunscreen, insect repellent, and a light jacket for mountain mornings. For temples, shoulders and knees must be covered (sarongs are provided). Don\'t forget your camera!'
      },
      {
        question: 'Is this package customizable?',
        answer: 'Yes! This package can be customized to extend your stay, add activities like diving certification, private beach dinners, or helicopter tours. Contact our team to discuss your preferences and we\'ll create your perfect honeymoon itinerary.'
      },
      {
        question: 'What is the COVID-19 policy?',
        answer: 'We follow all current health guidelines. Free date changes are available if travel restrictions affect your trip. All our partners maintain enhanced hygiene protocols. Travel insurance covering COVID-19 is strongly recommended.'
      }
    ],
    
    // Package-specific testimonials
    packageTestimonials: [
      {
        name: 'Emma & David',
        location: 'London, UK',
        image: 'https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?w=100',
        rating: 5,
        date: 'June 2025',
        text: 'Our Bali honeymoon exceeded all expectations! The private villa was stunning, and the sunrise trek was the highlight. The team thought of every detail. Truly magical!'
      },
      {
        name: 'Sarah & Michael',
        location: 'Sydney, Australia',
        image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100',
        rating: 5,
        date: 'May 2025',
        text: 'From the romantic dinners to the couples spa, everything was perfect. The cooking class was so fun and the Nusa Penida trip was breathtaking. Best honeymoon ever!'
      },
      {
        name: 'Jessica & Ryan',
        location: 'Toronto, Canada',
        image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100',
        rating: 5,
        date: 'April 2025',
        text: 'The attention to detail was incredible. Our guide was knowledgeable and the accommodations were luxurious. Bali stole our hearts and we\'re already planning to return!'
      }
    ]
  },
  {
    id: 'japan-cultural',
    title: 'Japan Cultural Discovery',
    destination: 'tokyo',
    image: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=800',
    themes: ['cultural', 'solo', 'friends'],
    duration: 10,
    price: 331917,
    originalPrice: 373417,
    rating: 4.8,
    reviews: 89,
    description: 'Immerse yourself in Japanese culture from Tokyo to Kyoto. Experience ancient temples, traditional ceremonies, and culinary delights on this comprehensive cultural journey.',
    longDescription: 'Discover the soul of Japan on this 10-day cultural odyssey that takes you from the neon-lit streets of Tokyo to the serene temples of Kyoto. Experience the perfect harmony of ancient traditions and cutting-edge modernity. Participate in traditional tea ceremonies, explore centuries-old shrines, witness the beauty of Japanese gardens, and savor authentic cuisine from street food to kaiseki dining.',
    highlights: ['Tokyo Exploration', 'Kyoto Temples', 'Tea Ceremony', 'Bullet Train'],
    maxGroupSize: 6,
    isGroupPackage: false,
    
    itinerary: [
      {
        day: 1,
        title: 'Welcome to Tokyo',
        description: 'Arrive at Narita or Haneda Airport. Private transfer to your hotel in Shinjuku. Evening orientation walk through the vibrant streets of Shinjuku and optional visit to an izakaya (Japanese pub) for welcome dinner.',
        meals: ['Dinner'],
        accommodation: 'Boutique Hotel, Shinjuku',
        image: 'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=800',
        activities: ['Airport transfer', 'Shinjuku evening walk', 'Welcome dinner']
      },
      {
        day: 2,
        title: 'Traditional Tokyo',
        description: 'Morning visit to Senso-ji Temple in Asakusa, Tokyo\'s oldest temple. Explore Nakamise shopping street. Afternoon in Harajuku and Meiji Shrine. Evening in Shibuya with the famous crossing experience.',
        meals: ['Breakfast'],
        accommodation: 'Boutique Hotel, Shinjuku',
        image: 'https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=800',
        activities: ['Senso-ji Temple', 'Nakamise Street', 'Meiji Shrine', 'Shibuya Crossing']
      },
      {
        day: 3,
        title: 'Modern Tokyo & Culinary Experience',
        description: 'Morning visit to Tsukiji Outer Market for sushi breakfast. TeamLab Borderless digital art museum. Afternoon cooking class to learn sushi and ramen making. Evening free to explore Ginza.',
        meals: ['Breakfast', 'Lunch'],
        accommodation: 'Boutique Hotel, Shinjuku',
        image: 'https://images.unsplash.com/photo-1553621042-f6e147245754?w=800',
        activities: ['Tsukiji Market', 'TeamLab Borderless', 'Cooking class']
      },
      {
        day: 4,
        title: 'Day Trip to Mount Fuji',
        description: 'Full-day excursion to Mount Fuji. Visit Fuji Five Lakes region, Chureito Pagoda for iconic photos. Optional boat ride on Lake Kawaguchi. Enjoy local Hoto noodles for lunch. Return to Tokyo.',
        meals: ['Breakfast', 'Lunch'],
        accommodation: 'Boutique Hotel, Shinjuku',
        image: 'https://images.unsplash.com/photo-1490806843957-31f4c9a91c65?w=800',
        activities: ['Mount Fuji views', 'Chureito Pagoda', 'Lake Kawaguchi', 'Hoto noodles']
      },
      {
        day: 5,
        title: 'Bullet Train to Kyoto',
        description: 'Experience the Shinkansen bullet train to Kyoto. Afternoon visit to Fushimi Inari Shrine with its famous thousand torii gates. Evening stroll through Gion district, the geisha quarter.',
        meals: ['Breakfast'],
        accommodation: 'Traditional Ryokan, Kyoto',
        image: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=800',
        activities: ['Shinkansen experience', 'Fushimi Inari Shrine', 'Gion district walk']
      },
      {
        day: 6,
        title: 'Kyoto Temples & Tea Ceremony',
        description: 'Morning visit to Kinkaku-ji (Golden Pavilion) and Ryoan-ji rock garden. Traditional tea ceremony experience in a historic tea house. Afternoon at Nijo Castle. Evening kaiseki dinner.',
        meals: ['Breakfast', 'Dinner'],
        accommodation: 'Traditional Ryokan, Kyoto',
        image: 'https://images.unsplash.com/photo-1545569341-9eb8b30979d9?w=800',
        activities: ['Kinkaku-ji', 'Ryoan-ji', 'Tea ceremony', 'Nijo Castle', 'Kaiseki dinner']
      },
      {
        day: 7,
        title: 'Arashiyama & Bamboo Grove',
        description: 'Explore the famous Arashiyama Bamboo Grove. Visit Tenryu-ji Temple and its beautiful gardens. Kimono rental experience with photo session. Afternoon boat ride on the Hozu River.',
        meals: ['Breakfast', 'Lunch'],
        accommodation: 'Traditional Ryokan, Kyoto',
        image: 'https://images.unsplash.com/photo-1528164344705-47542687000d?w=800',
        activities: ['Bamboo Grove', 'Tenryu-ji Temple', 'Kimono experience', 'River boat ride']
      },
      {
        day: 8,
        title: 'Day Trip to Nara',
        description: 'Day trip to Nara, Japan\'s first permanent capital. Visit Todai-ji Temple housing the Great Buddha. Interact with the friendly deer in Nara Park. Explore Kasuga Taisha shrine. Return to Kyoto.',
        meals: ['Breakfast'],
        accommodation: 'Traditional Ryokan, Kyoto',
        image: 'https://images.unsplash.com/photo-1524413840807-0c3cb6fa808d?w=800',
        activities: ['Todai-ji Temple', 'Great Buddha', 'Nara Park deer', 'Kasuga Taisha']
      },
      {
        day: 9,
        title: 'Osaka Day Trip',
        description: 'Day trip to Osaka. Visit Osaka Castle and its museum. Explore Dotonbori entertainment district. Street food tour including takoyaki and okonomiyaki. Return to Kyoto for final evening.',
        meals: ['Breakfast', 'Lunch'],
        accommodation: 'Traditional Ryokan, Kyoto',
        image: 'https://images.unsplash.com/photo-1590559899731-a382839e5549?w=800',
        activities: ['Osaka Castle', 'Dotonbori', 'Street food tour']
      },
      {
        day: 10,
        title: 'Departure',
        description: 'Morning at leisure for last-minute shopping at Nishiki Market. Transfer to Kansai International Airport or Shinkansen to Tokyo for departure. Sayonara and safe travels!',
        meals: ['Breakfast'],
        accommodation: null,
        image: 'https://images.unsplash.com/photo-1492571350019-22de08371fd3?w=800',
        activities: ['Nishiki Market', 'Airport transfer']
      }
    ],
    
    gallery: [
      { url: 'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=800', caption: 'Tokyo Skyline' },
      { url: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=800', caption: 'Fushimi Inari' },
      { url: 'https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=800', caption: 'Senso-ji Temple' },
      { url: 'https://images.unsplash.com/photo-1490806843957-31f4c9a91c65?w=800', caption: 'Mount Fuji' },
      { url: 'https://images.unsplash.com/photo-1545569341-9eb8b30979d9?w=800', caption: 'Golden Pavilion' },
      { url: 'https://images.unsplash.com/photo-1528164344705-47542687000d?w=800', caption: 'Bamboo Grove' },
      { url: 'https://images.unsplash.com/photo-1524413840807-0c3cb6fa808d?w=800', caption: 'Nara Deer' },
      { url: 'https://images.unsplash.com/photo-1553621042-f6e147245754?w=800', caption: 'Japanese Cuisine' }
    ],
    
    inclusions: [
      'Airport transfers (private)',
      '4 nights accommodation in Tokyo (Western-style hotel)',
      '5 nights accommodation in Kyoto (Traditional Ryokan)',
      'Daily breakfast',
      '7-day JR Rail Pass',
      'Shinkansen bullet train Tokyo-Kyoto',
      'All temple and museum entrance fees',
      'Mount Fuji day trip with guide',
      'Traditional tea ceremony experience',
      'Sushi & ramen cooking class',
      'Kimono rental with photo session',
      'Hozu River boat ride',
      'Nara day trip with guide',
      'Osaka food tour',
      'Kaiseki dinner experience',
      'English-speaking guides',
      'Pocket WiFi rental',
      '24/7 support'
    ],
    
    exclusions: [
      'International flights',
      'Travel insurance',
      'Meals not specified',
      'Personal expenses',
      'Optional activities',
      'Tips and gratuities',
      'Camera fees at some locations',
      'Alcoholic beverages'
    ],
    
    termsAndConditions: [
      'Booking requires 30% deposit',
      'Full payment due 45 days before departure',
      'Cancellation 30+ days: 70% refund',
      'Cancellation 15-29 days: 50% refund',
      'Cancellation <15 days: No refund',
      'Itinerary subject to change',
      'Valid passport required',
      'Travel insurance mandatory'
    ],
    
    faqs: [
      {
        question: 'What is a Ryokan?',
        answer: 'A Ryokan is a traditional Japanese inn featuring tatami floors, futon beds, communal baths (onsen), and often includes kaiseki dinner and breakfast. It\'s an essential Japanese cultural experience.'
      },
      {
        question: 'Is this trip suitable for vegetarians?',
        answer: 'Yes, though it requires planning. We can arrange vegetarian alternatives for all meals. Japanese cuisine offers many vegetable and tofu-based dishes. Please inform us when booking.'
      },
      {
        question: 'How much walking is involved?',
        answer: 'Expect to walk 5-8 km daily. Most sightseeing involves walking through temples and neighborhoods. Comfortable walking shoes are essential. The pace is relaxed with frequent breaks.'
      },
      {
        question: 'Is the JR Pass worth it?',
        answer: 'Absolutely! The 7-day JR Pass (included) covers the Shinkansen, local JR trains, and some buses. It offers unlimited travel and significant savings compared to individual tickets.'
      }
    ],
    
    packageTestimonials: [
      {
        name: 'Mark Thompson',
        location: 'New York, USA',
        image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100',
        rating: 5,
        date: 'May 2025',
        text: 'This trip completely changed how I see Japan. The balance of traditional and modern was perfect. The ryokan experience was unforgettable!'
      },
      {
        name: 'Lisa Chen',
        location: 'Singapore',
        image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100',
        rating: 5,
        date: 'April 2025',
        text: 'As a solo traveler, I felt completely taken care of. The tea ceremony and cooking class were highlights. Can\'t wait to return!'
      }
    ]
  },
  {
    id: 'maldives-luxury',
    title: 'Maldives Luxury Retreat',
    destination: 'maldives',
    image: 'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=800',
    themes: ['honeymoon', 'wellness', 'couple'],
    duration: 6,
    price: 497917,
    originalPrice: 580917,
    rating: 5.0,
    reviews: 67,
    description: 'Ultimate luxury in paradise. Overwater villa, gourmet dining, and world-class spa await in this exclusive Maldives retreat.',
    longDescription: 'Experience unparalleled luxury in the Maldives, where crystal-clear waters meet pristine white sand beaches. Stay in an iconic overwater villa with direct lagoon access, indulge in world-class spa treatments, and discover vibrant marine life. This all-inclusive retreat offers the perfect escape from everyday life.',
    highlights: ['Overwater Villa', 'Private Beach', 'Snorkeling', 'Sunset Cruise'],
    maxGroupSize: 2,
    isGroupPackage: false,
    
    itinerary: [
      {
        day: 1,
        title: 'Paradise Arrival',
        description: 'Arrive at Malé Airport and transfer via seaplane to your private island resort. Check into your luxurious overwater villa with panoramic ocean views. Welcome champagne and fruit basket. Evening sunset dinner on the beach.',
        meals: ['Dinner'],
        accommodation: 'Overwater Villa',
        image: 'https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=800',
        activities: ['Seaplane transfer', 'Villa check-in', 'Beach sunset dinner']
      },
      {
        day: 2,
        title: 'Spa & Relaxation',
        description: 'Wake up to breakfast served on your private deck. Morning couples spa journey including massage, body treatment, and hydrotherapy. Afternoon at leisure - swim in your private infinity pool or relax on the sundeck. Romantic dinner at the overwater restaurant.',
        meals: ['Breakfast', 'Lunch', 'Dinner'],
        accommodation: 'Overwater Villa',
        image: 'https://images.unsplash.com/photo-1540555700478-4be289fbec6d?w=800',
        activities: ['In-villa breakfast', '3-hour spa journey', 'Overwater dining']
      },
      {
        day: 3,
        title: 'Marine Discovery',
        description: 'Guided snorkeling excursion to the house reef. Discover colorful coral gardens and tropical fish. Afternoon dolphin cruise to spot spinner dolphins. Evening beach BBQ under the stars with live music.',
        meals: ['Breakfast', 'Lunch', 'Dinner'],
        accommodation: 'Overwater Villa',
        image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800',
        activities: ['Snorkeling excursion', 'Dolphin cruise', 'Beach BBQ']
      },
      {
        day: 4,
        title: 'Adventure Day',
        description: 'Choose your adventure: scuba diving, parasailing, or jet skiing. Gourmet picnic on a private sandbank - just the two of you surrounded by turquoise waters. Sunset fishing trip followed by cook-your-catch dinner.',
        meals: ['Breakfast', 'Lunch', 'Dinner'],
        accommodation: 'Overwater Villa',
        image: 'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=800',
        activities: ['Water sports', 'Private sandbank picnic', 'Sunset fishing']
      },
      {
        day: 5,
        title: 'Wellness & Romance',
        description: 'Sunrise yoga on the beach. Cooking class featuring Maldivian cuisine. Afternoon free for relaxation or optional water activities. Private cinema screening on the beach with champagne and canapés.',
        meals: ['Breakfast', 'Lunch', 'Dinner'],
        accommodation: 'Overwater Villa',
        image: 'https://images.unsplash.com/photo-1439130490301-25e322d88054?w=800',
        activities: ['Beach yoga', 'Cooking class', 'Private beach cinema']
      },
      {
        day: 6,
        title: 'Farewell Paradise',
        description: 'Final sunrise from your overwater villa. Leisurely breakfast. Time for last-minute photos or a final dip in the lagoon. Seaplane transfer back to Malé for your departure.',
        meals: ['Breakfast'],
        accommodation: null,
        image: 'https://images.unsplash.com/photo-1586500038052-4e5e59fe3dd5?w=800',
        activities: ['Sunrise photos', 'Final swim', 'Seaplane transfer']
      }
    ],
    
    gallery: [
      { url: 'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=800', caption: 'Overwater Villas' },
      { url: 'https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=800', caption: 'Crystal Clear Waters' },
      { url: 'https://images.unsplash.com/photo-1540555700478-4be289fbec6d?w=800', caption: 'Spa Sanctuary' },
      { url: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800', caption: 'Underwater Paradise' },
      { url: 'https://images.unsplash.com/photo-1439130490301-25e322d88054?w=800', caption: 'Beach Sunset' },
      { url: 'https://images.unsplash.com/photo-1586500038052-4e5e59fe3dd5?w=800', caption: 'Private Island' }
    ],
    
    inclusions: [
      'Seaplane transfers Malé-Resort-Malé',
      '5 nights in Overwater Villa with private pool',
      'All-inclusive meal plan (breakfast, lunch, dinner)',
      'Premium alcoholic and non-alcoholic beverages',
      'Daily minibar replenishment',
      '3-hour couples spa journey',
      'Guided snorkeling excursion with equipment',
      'Dolphin sunset cruise',
      'Private sandbank picnic',
      'Beach BBQ dinner',
      'Sunset fishing trip with cook-your-catch',
      'Beach yoga sessions',
      'Maldivian cooking class',
      'Private beach cinema experience',
      'Non-motorized water sports (kayaking, paddleboarding)',
      '24-hour butler service',
      'WiFi throughout resort'
    ],
    
    exclusions: [
      'International flights',
      'Travel insurance',
      'Motorized water sports (diving, parasailing, jet ski)',
      'Spa treatments beyond included package',
      'Premium wines and spirits',
      'Personal shopping',
      'Tips and gratuities',
      'Visa fees (if applicable)'
    ],
    
    termsAndConditions: [
      '50% deposit required at booking',
      'Full payment 60 days before arrival',
      'Cancellation 45+ days: 75% refund',
      'Cancellation 30-44 days: 50% refund',
      'Cancellation <30 days: No refund',
      'Resort may substitute equal accommodations if necessary',
      'Weather may affect seaplane transfers',
      'Minimum age: 12 years for this package'
    ],
    
    faqs: [
      {
        question: 'How do we get to the resort?',
        answer: 'You\'ll take a scenic 45-minute seaplane from Malé Airport directly to the resort\'s lagoon. Seaplanes operate during daylight hours only, so early arrivals may require a night in Malé (we can arrange this).'
      },
      {
        question: 'What\'s included in all-inclusive?',
        answer: 'All meals at any restaurant, premium beverages including champagne and cocktails, minibar, and select activities. Spa beyond the included package, premium wines, and motorized sports are extra.'
      },
      {
        question: 'Is the snorkeling suitable for beginners?',
        answer: 'Absolutely! Our house reef is perfect for beginners with calm, shallow waters and abundant marine life. Guides provide full instruction and flotation devices are available.'
      },
      {
        question: 'What\'s the weather like?',
        answer: 'The Maldives enjoys warm tropical weather year-round (28-32°C). November-April is dry season with calm seas. May-October sees occasional rain but often better diving visibility and fewer tourists.'
      }
    ],
    
    packageTestimonials: [
      {
        name: 'James & Sophie',
        location: 'Melbourne, Australia',
        image: 'https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?w=100',
        rating: 5,
        date: 'March 2025',
        text: 'Words cannot describe how perfect this trip was. The overwater villa was a dream, and the staff made us feel like royalty. The sandbank picnic was absolutely magical!'
      },
      {
        name: 'Robert & Nina',
        location: 'Dubai, UAE',
        image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100',
        rating: 5,
        date: 'February 2025',
        text: 'This was our anniversary trip and exceeded all expectations. The butler service was incredible, and the dolphin cruise was a highlight we\'ll never forget.'
      }
    ]
  },
  {
    id: 'swiss-adventure',
    title: 'Swiss Alps Adventure',
    destination: 'swiss-alps',
    image: 'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=800',
    themes: ['adventure', 'friends'],
    duration: 8,
    price: 356817,
    originalPrice: 398317,
    rating: 4.7,
    reviews: 56,
    description: 'Conquer the Alps with hiking, paragliding, and scenic train journeys through breathtaking landscapes.',
    longDescription: 'Experience the ultimate Alpine adventure through Switzerland\'s most spectacular landscapes. From the iconic Matterhorn to the stunning Jungfrau region, this action-packed journey combines thrilling activities with breathtaking scenery and Swiss hospitality.',
    highlights: ['Jungfrau Hike', 'Paragliding', 'Glacier Express', 'Mountain Villages'],
    maxGroupSize: 8,
    isGroupPackage: false,
    
    itinerary: [
      { day: 1, title: 'Zurich Arrival', description: 'Arrive in Zurich. City walking tour. Transfer to Lucerne.', meals: ['Dinner'], accommodation: 'Hotel, Lucerne', image: 'https://images.unsplash.com/photo-1515488764276-beab7607c1e6?w=800', activities: ['Zurich tour', 'Lucerne transfer'] },
      { day: 2, title: 'Mount Pilatus', description: 'Cable car to Mount Pilatus. Panoramic views. Lake Lucerne cruise.', meals: ['Breakfast', 'Lunch'], accommodation: 'Hotel, Lucerne', image: 'https://images.unsplash.com/photo-1527668752968-14dc70a27c95?w=800', activities: ['Mount Pilatus', 'Lake cruise'] },
      { day: 3, title: 'Interlaken Adventure', description: 'Train to Interlaken. Afternoon paragliding over the Alps.', meals: ['Breakfast'], accommodation: 'Chalet, Interlaken', image: 'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=800', activities: ['Paragliding', 'Interlaken exploration'] },
      { day: 4, title: 'Jungfrau Top of Europe', description: 'Train to Jungfraujoch. Hike on the glacier. Ice Palace visit.', meals: ['Breakfast', 'Lunch'], accommodation: 'Chalet, Interlaken', image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800', activities: ['Jungfraujoch', 'Glacier hike'] },
      { day: 5, title: 'Grindelwald Hiking', description: 'Full day hiking in Grindelwald with Eiger views.', meals: ['Breakfast', 'Lunch'], accommodation: 'Chalet, Interlaken', image: 'https://images.unsplash.com/photo-1508739773434-c26b3d09e071?w=800', activities: ['Grindelwald hike'] },
      { day: 6, title: 'Glacier Express', description: 'Scenic Glacier Express train to Zermatt.', meals: ['Breakfast', 'Lunch'], accommodation: 'Hotel, Zermatt', image: 'https://images.unsplash.com/photo-1491555103944-7c647fd857e6?w=800', activities: ['Glacier Express journey'] },
      { day: 7, title: 'Matterhorn Day', description: 'Gornergrat railway for Matterhorn views. Optional hike.', meals: ['Breakfast', 'Dinner'], accommodation: 'Hotel, Zermatt', image: 'https://images.unsplash.com/photo-1529963183134-61a90db47eaf?w=800', activities: ['Gornergrat', 'Matterhorn views'] },
      { day: 8, title: 'Departure', description: 'Transfer to Geneva or Zurich for departure.', meals: ['Breakfast'], accommodation: null, image: 'https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99?w=800', activities: ['Airport transfer'] }
    ],
    
    gallery: [
      { url: 'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=800', caption: 'Alpine Peaks' },
      { url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800', caption: 'Jungfrau Region' },
      { url: 'https://images.unsplash.com/photo-1529963183134-61a90db47eaf?w=800', caption: 'Matterhorn' },
      { url: 'https://images.unsplash.com/photo-1491555103944-7c647fd857e6?w=800', caption: 'Glacier Express' }
    ],
    
    inclusions: ['Swiss Travel Pass', 'All accommodations', 'Paragliding experience', 'Jungfraujoch ticket', 'Glacier Express reservation', 'Guided hikes', 'Most meals'],
    exclusions: ['International flights', 'Travel insurance', 'Personal expenses', 'Optional activities', 'Tips'],
    termsAndConditions: ['30% deposit required', 'Full payment 45 days before', 'Weather may affect activities', 'Moderate fitness required'],
    
    faqs: [
      { question: 'What fitness level is required?', answer: 'Moderate fitness is needed. Hikes are 4-6 hours at altitude. Training beforehand is recommended.' },
      { question: 'Is paragliding safe?', answer: 'Yes! Tandem flights are with certified instructors. No experience needed. Weather-dependent.' }
    ],
    
    packageTestimonials: [
      { name: 'Alex Johnson', location: 'Boston, USA', image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100', rating: 5, date: 'July 2025', text: 'The paragliding and Glacier Express were incredible! Best adventure trip ever!' }
    ]
  },
  {
    id: 'costa-rica-family',
    title: 'Costa Rica Family Adventure',
    destination: 'costa-rica',
    image: 'https://images.unsplash.com/photo-1518259102261-b40117eabbc9?w=800',
    themes: ['family', 'adventure'],
    duration: 9,
    price: 290417,
    originalPrice: 331917,
    rating: 4.8,
    reviews: 78,
    description: 'Perfect family getaway with wildlife, rainforests, and age-appropriate adventures for all.',
    longDescription: 'Create unforgettable family memories in Costa Rica, where adventure meets wildlife in a safe, family-friendly environment. From zip-lining through rainforest canopies to spotting monkeys and sloths, this trip offers excitement for every age.',
    highlights: ['Rainforest Walk', 'Wildlife Spotting', 'Beach Time', 'Volcano Visit'],
    maxGroupSize: 6,
    isGroupPackage: false,
    
    itinerary: [
      { day: 1, title: 'Welcome to Costa Rica', description: 'Arrive San José. Transfer to Arenal.', meals: ['Dinner'], accommodation: 'Family Suite, Arenal', image: 'https://images.unsplash.com/photo-1518259102261-b40117eabbc9?w=800', activities: ['Airport pickup', 'Arenal transfer'] },
      { day: 2, title: 'Arenal Volcano', description: 'Volcano hike, hot springs, wildlife walk.', meals: ['Breakfast', 'Dinner'], accommodation: 'Family Suite, Arenal', image: 'https://images.unsplash.com/photo-1552733407-5d5c46c3bb3b?w=800', activities: ['Volcano hike', 'Hot springs'] },
      { day: 3, title: 'Zip-line Adventure', description: 'Family zip-line course, hanging bridges, chocolate tour.', meals: ['Breakfast', 'Lunch'], accommodation: 'Family Suite, Arenal', image: 'https://images.unsplash.com/photo-1534430480872-3498386e7856?w=800', activities: ['Zip-lining', 'Hanging bridges'] },
      { day: 4, title: 'Monteverde Cloud Forest', description: 'Transfer to Monteverde. Night walk to see nocturnal wildlife.', meals: ['Breakfast', 'Dinner'], accommodation: 'Lodge, Monteverde', image: 'https://images.unsplash.com/photo-1528183429752-a97d0bf99b5a?w=800', activities: ['Night walk'] },
      { day: 5, title: 'Cloud Forest Exploration', description: 'Guided forest walk, butterfly garden, hummingbird sanctuary.', meals: ['Breakfast', 'Lunch'], accommodation: 'Lodge, Monteverde', image: 'https://images.unsplash.com/photo-1551123424-8a35eb9e2cb7?w=800', activities: ['Forest walk', 'Butterfly garden'] },
      { day: 6, title: 'Manuel Antonio Beach', description: 'Transfer to Manuel Antonio. Afternoon at the beach.', meals: ['Breakfast'], accommodation: 'Beach Resort, Manuel Antonio', image: 'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=800', activities: ['Beach time'] },
      { day: 7, title: 'National Park', description: 'Manuel Antonio National Park wildlife tour. Beach swimming.', meals: ['Breakfast', 'Lunch'], accommodation: 'Beach Resort, Manuel Antonio', image: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=800', activities: ['National park tour', 'Monkey spotting'] },
      { day: 8, title: 'Water Fun', description: 'Kayaking, optional surfing lessons, catamaran cruise.', meals: ['Breakfast', 'Dinner'], accommodation: 'Beach Resort, Manuel Antonio', image: 'https://images.unsplash.com/photo-1506929562872-bb421503ef21?w=800', activities: ['Kayaking', 'Catamaran cruise'] },
      { day: 9, title: 'Departure', description: 'Transfer to San José airport.', meals: ['Breakfast'], accommodation: null, image: 'https://images.unsplash.com/photo-1494515843206-f3117d3f51b7?w=800', activities: ['Airport transfer'] }
    ],
    
    gallery: [
      { url: 'https://images.unsplash.com/photo-1518259102261-b40117eabbc9?w=800', caption: 'Sloth' },
      { url: 'https://images.unsplash.com/photo-1552733407-5d5c46c3bb3b?w=800', caption: 'Arenal Volcano' },
      { url: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=800', caption: 'Manuel Antonio' },
      { url: 'https://images.unsplash.com/photo-1534430480872-3498386e7836?w=800', caption: 'Zip-lining' }
    ],
    
    inclusions: ['All transfers', 'Family accommodations', 'Most meals', 'Guided tours', 'Zip-line', 'Park fees', 'Hot springs', 'Catamaran cruise'],
    exclusions: ['Flights', 'Travel insurance', 'Personal expenses', 'Optional activities', 'Tips'],
    termsAndConditions: ['Suitable for ages 6+', '30% deposit required', 'Activities weather-dependent'],
    
    faqs: [
      { question: 'What ages is this suitable for?', answer: 'Best for families with children 6+. Younger children may need modified activities.' },
      { question: 'Are the activities safe for kids?', answer: 'Yes! All activities have appropriate safety measures. Zip-lines have weight/height requirements.' }
    ],
    
    packageTestimonials: [
      { name: 'The Rodriguez Family', location: 'Miami, USA', image: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=100', rating: 5, date: 'July 2025', text: 'Our kids still talk about the sloths and zip-lining! Perfect family vacation.' }
    ]
  },
  {
    id: 'paris-romance',
    title: 'Parisian Romance',
    destination: 'paris',
    image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800',
    themes: ['couple', 'honeymoon', 'cultural'],
    duration: 5,
    price: 232317,
    originalPrice: 265517,
    rating: 4.9,
    reviews: 112,
    description: 'Fall in love with Paris. Iconic landmarks, gourmet dining, and romantic experiences await.',
    longDescription: 'Experience the City of Light with your loved one. From champagne at the Eiffel Tower to strolls along the Seine, this romantic getaway captures the essence of Parisian love.',
    highlights: ['Eiffel Tower Dinner', 'Louvre Tour', 'Seine Cruise', 'Montmartre Walk'],
    maxGroupSize: 2,
    isGroupPackage: false,
    
    itinerary: [
      { day: 1, title: 'Bonjour Paris', description: 'Arrive CDG. Private transfer. Evening Seine dinner cruise.', meals: ['Dinner'], accommodation: 'Boutique Hotel, Le Marais', image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800', activities: ['Seine cruise dinner'] },
      { day: 2, title: 'Iconic Paris', description: 'Eiffel Tower with champagne. Louvre private guide tour. Tuileries walk.', meals: ['Breakfast'], accommodation: 'Boutique Hotel, Le Marais', image: 'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=800', activities: ['Eiffel Tower', 'Louvre tour'] },
      { day: 3, title: 'Montmartre & Arts', description: 'Montmartre walking tour. Sacré-Cœur. Wine tasting. Cooking class.', meals: ['Breakfast', 'Lunch'], accommodation: 'Boutique Hotel, Le Marais', image: 'https://images.unsplash.com/photo-1549144511-f099e773c147?w=800', activities: ['Montmartre tour', 'Cooking class'] },
      { day: 4, title: 'Versailles Day', description: 'Day trip to Versailles. Palace and gardens. Farewell dinner.', meals: ['Breakfast', 'Dinner'], accommodation: 'Boutique Hotel, Le Marais', image: 'https://images.unsplash.com/photo-1551410224-699683e15636?w=800', activities: ['Versailles tour', 'Gardens'] },
      { day: 5, title: 'Au Revoir', description: 'Breakfast at leisure. Transfer to airport.', meals: ['Breakfast'], accommodation: null, image: 'https://images.unsplash.com/photo-1431274172761-fca41d930114?w=800', activities: ['Departure'] }
    ],
    
    gallery: [
      { url: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800', caption: 'Eiffel Tower' },
      { url: 'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=800', caption: 'Louvre' },
      { url: 'https://images.unsplash.com/photo-1549144511-f099e773c147?w=800', caption: 'Montmartre' },
      { url: 'https://images.unsplash.com/photo-1551410224-699683e15636?w=800', caption: 'Versailles' }
    ],
    
    inclusions: ['Airport transfers', '4 nights boutique hotel', 'Eiffel Tower tickets + champagne', 'Louvre private tour', 'Seine dinner cruise', 'Versailles tour', 'Cooking class', 'Daily breakfast'],
    exclusions: ['Flights', 'Travel insurance', 'Meals not listed', 'Tips'],
    termsAndConditions: ['30% deposit', 'Full payment 30 days before', 'Museum tickets non-refundable'],
    
    faqs: [
      { question: 'Best time to visit Paris?', answer: 'April-June and September-October offer mild weather and fewer crowds. Spring brings blooming flowers, fall has lovely colors.' }
    ],
    
    packageTestimonials: [
      { name: 'Anna & Peter', location: 'Copenhagen, Denmark', image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100', rating: 5, date: 'May 2025', text: 'Paris was pure magic! The Seine dinner cruise was the highlight of our trip.' }
    ]
  },
  {
    id: 'greece-friends',
    title: 'Greek Islands Hopping',
    destination: 'santorini',
    image: 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=800',
    themes: ['friends', 'adventure'],
    duration: 10,
    price: 273817,
    originalPrice: 315317,
    rating: 4.8,
    reviews: 94,
    description: 'Island hop through Greece with your best friends. Beaches, parties, and ancient history.',
    longDescription: 'Experience the best of Greece on this epic island-hopping adventure through Athens, Mykonos, and Santorini. Perfect for groups of friends seeking sun, culture, and unforgettable nightlife.',
    highlights: ['Santorini Sunset', 'Mykonos Nightlife', 'Athens History', 'Beach Hopping'],
    maxGroupSize: 12,
    isGroupPackage: true,
    
    itinerary: [
      { day: 1, title: 'Athens Arrival', description: 'Welcome dinner in Plaka.', meals: ['Dinner'], accommodation: 'Hotel, Athens', image: 'https://images.unsplash.com/photo-1555993539-1732b0258235?w=800', activities: ['Plaka dinner'] },
      { day: 2, title: 'Ancient Athens', description: 'Acropolis, Parthenon, Ancient Agora tour.', meals: ['Breakfast'], accommodation: 'Hotel, Athens', image: 'https://images.unsplash.com/photo-1503152394-c571994fd383?w=800', activities: ['Acropolis tour'] },
      { day: 3, title: 'Ferry to Mykonos', description: 'Ferry journey. Beach evening.', meals: ['Breakfast'], accommodation: 'Hotel, Mykonos', image: 'https://images.unsplash.com/photo-1533105079780-92b9be482077?w=800', activities: ['Ferry', 'Beach'] },
      { day: 4, title: 'Mykonos Beaches', description: 'Paradise Beach, Little Venice, nightlife.', meals: ['Breakfast'], accommodation: 'Hotel, Mykonos', image: 'https://images.unsplash.com/photo-1560703650-ef3e0f254ae0?w=800', activities: ['Beach hopping', 'Nightlife'] },
      { day: 5, title: 'Mykonos Free Day', description: 'Optional diving or relaxation.', meals: ['Breakfast'], accommodation: 'Hotel, Mykonos', image: 'https://images.unsplash.com/photo-1586276514672-93d4e9a4f9e7?w=800', activities: ['Free day'] },
      { day: 6, title: 'Santorini', description: 'Ferry to Santorini. Fira exploration.', meals: ['Breakfast', 'Dinner'], accommodation: 'Cave Hotel, Santorini', image: 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=800', activities: ['Ferry', 'Fira walk'] },
      { day: 7, title: 'Oia Sunset', description: 'Oia village tour, famous sunset, wine tasting.', meals: ['Breakfast'], accommodation: 'Cave Hotel, Santorini', image: 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=800', activities: ['Oia sunset', 'Wine tasting'] },
      { day: 8, title: 'Volcano & Hot Springs', description: 'Boat trip to volcano, hot springs swim.', meals: ['Breakfast', 'Lunch'], accommodation: 'Cave Hotel, Santorini', image: 'https://images.unsplash.com/photo-1601581875039-e899893d520c?w=800', activities: ['Volcano trip', 'Hot springs'] },
      { day: 9, title: 'Beach Day', description: 'Red Beach, Black Beach, farewell dinner.', meals: ['Breakfast', 'Dinner'], accommodation: 'Cave Hotel, Santorini', image: 'https://images.unsplash.com/photo-1572444254390-e4e8eec8d234?w=800', activities: ['Beaches', 'Farewell dinner'] },
      { day: 10, title: 'Departure', description: 'Transfer to Santorini airport or Athens.', meals: ['Breakfast'], accommodation: null, image: 'https://images.unsplash.com/photo-1580502304784-8985b7eb7260?w=800', activities: ['Departure'] }
    ],
    
    gallery: [
      { url: 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=800', caption: 'Santorini' },
      { url: 'https://images.unsplash.com/photo-1533105079780-92b9be482077?w=800', caption: 'Mykonos' },
      { url: 'https://images.unsplash.com/photo-1555993539-1732b0258235?w=800', caption: 'Athens' },
      { url: 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=800', caption: 'Oia Sunset' }
    ],
    
    inclusions: ['All ferry tickets', 'Accommodations', 'Acropolis tour', 'Volcano boat trip', 'Wine tasting', 'Select meals', 'Local guide'],
    exclusions: ['Flights', 'Travel insurance', 'Most meals', 'Nightlife expenses', 'Tips'],
    termsAndConditions: ['Group of 4+ required', '30% deposit', 'Ferry schedules subject to change'],
    
    faqs: [
      { question: 'How do we get between islands?', answer: 'High-speed ferries connect the islands. Journeys are 2-5 hours with stunning sea views.' }
    ],
    
    packageTestimonials: [
      { name: 'College Friends', location: 'Boston, USA', image: 'https://images.unsplash.com/photo-1539635278303-d4002c07eae3?w=100', rating: 5, date: 'August 2025', text: 'Best friends trip ever! Santorini sunsets and Mykonos parties were unforgettable.' }
    ]
  },
  {
    id: 'dubai-family',
    title: 'Dubai Family Fun',
    destination: 'dubai',
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800',
    themes: ['family'],
    duration: 6,
    price: 248917,
    originalPrice: 290417,
    rating: 4.7,
    reviews: 83,
    description: 'Action-packed family vacation with theme parks, desert safari, and architectural wonders.',
    longDescription: 'Dubai offers an incredible family adventure combining futuristic attractions, desert experiences, and world-class entertainment. From the tallest building to underwater aquariums, create lasting memories.',
    highlights: ['Burj Khalifa', 'Desert Safari', 'Aquaventure', 'Dubai Mall'],
    maxGroupSize: 6,
    isGroupPackage: false,
    
    itinerary: [
      { day: 1, title: 'Welcome to Dubai', description: 'Airport transfer, Dubai Mall, Burj Khalifa sunset.', meals: ['Dinner'], accommodation: 'Family Suite, Downtown', image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800', activities: ['Burj Khalifa', 'Dubai Mall'] },
      { day: 2, title: 'Theme Park Day', description: 'Full day at Dubai Parks & Resorts or IMG Worlds.', meals: ['Breakfast', 'Lunch'], accommodation: 'Family Suite, Downtown', image: 'https://images.unsplash.com/photo-1578894381163-e72c17f2d45f?w=800', activities: ['Theme parks'] },
      { day: 3, title: 'Desert Safari', description: 'Dune bashing, camel riding, BBQ dinner with entertainment.', meals: ['Breakfast', 'Dinner'], accommodation: 'Family Suite, Downtown', image: 'https://images.unsplash.com/photo-1451337516015-6b6e9a44a8a3?w=800', activities: ['Desert safari', 'BBQ dinner'] },
      { day: 4, title: 'Atlantis Day', description: 'Aquaventure waterpark, Lost Chambers aquarium.', meals: ['Breakfast', 'Lunch'], accommodation: 'Family Suite, Downtown', image: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800', activities: ['Aquaventure', 'Aquarium'] },
      { day: 5, title: 'Old Dubai & Creek', description: 'Dubai Frame, Creek dhow cruise, Gold Souk.', meals: ['Breakfast', 'Dinner'], accommodation: 'Family Suite, Downtown', image: 'https://images.unsplash.com/photo-1518684079-3c830dcef090?w=800', activities: ['Dubai Frame', 'Dhow cruise'] },
      { day: 6, title: 'Departure', description: 'Morning at leisure, airport transfer.', meals: ['Breakfast'], accommodation: null, image: 'https://images.unsplash.com/photo-1546412414-e1885259563a?w=800', activities: ['Departure'] }
    ],
    
    gallery: [
      { url: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800', caption: 'Burj Khalifa' },
      { url: 'https://images.unsplash.com/photo-1518684079-3c830dcef090?w=800', caption: 'Dubai Skyline' },
      { url: 'https://images.unsplash.com/photo-1451337516015-6b6e9a44a8a3?w=800', caption: 'Desert Safari' },
      { url: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800', caption: 'Atlantis' }
    ],
    
    inclusions: ['Airport transfers', 'Family suite 5 nights', 'Burj Khalifa tickets', 'Theme park day pass', 'Desert safari with dinner', 'Aquaventure tickets', 'Dubai Frame entry', 'Dhow cruise dinner'],
    exclusions: ['Flights', 'Travel insurance', 'Personal expenses', 'Shopping', 'Tips'],
    termsAndConditions: ['30% deposit', 'Kids under 3 free', 'Park tickets non-refundable'],
    
    faqs: [
      { question: 'Is Dubai safe for families?', answer: 'Dubai is one of the safest cities globally with very low crime rates. It\'s extremely family-friendly with excellent infrastructure.' },
      { question: 'What\'s the best time to visit?', answer: 'November to March offers pleasant weather (20-30°C). Summer months are very hot but have great indoor attractions and deals.' }
    ],
    
    packageTestimonials: [
      { name: 'The Williams Family', location: 'Chicago, USA', image: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=100', rating: 5, date: 'December 2024', text: 'Dubai was incredible for our family! Kids loved Aquaventure and the desert safari was a unique experience.' }
    ]
  }
];

export const groupPackages = [
  {
    id: 'bali-group-yoga',
    title: 'Bali Wellness & Yoga Retreat',
    destination: 'bali',
    image: 'https://images.unsplash.com/photo-1545389336-cf090694435e?w=800',
    themes: ['wellness', 'solo', 'friends'],
    duration: 7,
    price: 157617,
    originalPrice: 190817,
    rating: 4.9,
    reviews: 45,
    description: 'Join like-minded travelers for a transformative wellness journey in Bali.',
    highlights: ['Daily Yoga', 'Meditation Sessions', 'Healthy Cuisine', 'Temple Visits'],
    included: ['Accommodation', 'Meals', 'Yoga Classes', 'Tours'],
    departureDates: [
      { date: '2025-08-15', spotsLeft: 6 },
      { date: '2025-09-12', spotsLeft: 12 },
      { date: '2025-10-10', spotsLeft: 15 },
      { date: '2025-11-07', spotsLeft: 10 },
      { date: '2026-01-09', spotsLeft: 15 }
    ],
    nextDeparture: '2025-08-15',
    spotsLeft: 6,
    maxGroupSize: 15
  },
  {
    id: 'japan-group-culture',
    title: 'Japan Group Explorer',
    destination: 'tokyo',
    image: 'https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=800',
    themes: ['cultural', 'friends', 'solo'],
    duration: 12,
    price: 290417,
    originalPrice: 331917,
    rating: 4.8,
    reviews: 62,
    description: 'Explore Japan with a fun group of travelers. Expert guides and authentic experiences.',
    highlights: ['Tokyo to Osaka', 'Traditional Ryokan', 'Cooking Class', 'Geisha District'],
    included: ['Accommodation', 'Rail Pass', 'Guided Tours', 'Some Meals'],
    departureDates: [
      { date: '2025-09-01', spotsLeft: 8 },
      { date: '2025-10-15', spotsLeft: 14 },
      { date: '2025-11-20', spotsLeft: 16 },
      { date: '2026-03-15', spotsLeft: 16 },
      { date: '2026-04-01', spotsLeft: 16 }
    ],
    nextDeparture: '2025-09-01',
    spotsLeft: 8,
    maxGroupSize: 16
  },
  {
    id: 'costa-rica-adventure-group',
    title: 'Costa Rica Adventure Squad',
    destination: 'costa-rica',
    image: 'https://images.unsplash.com/photo-1552733407-5d5c46c3bb3b?w=800',
    themes: ['adventure', 'friends', 'solo'],
    duration: 10,
    price: 215717,
    originalPrice: 248917,
    rating: 4.7,
    reviews: 38,
    description: 'Epic adventure with new friends through Costa Rica\'s best natural wonders.',
    highlights: ['Zip-lining', 'White Water Rafting', 'Volcano Hike', 'Beach Days'],
    included: ['Accommodation', 'Adventures', 'Breakfast', 'Transfers'],
    departureDates: [
      { date: '2025-08-20', spotsLeft: 10 },
      { date: '2025-09-25', spotsLeft: 14 },
      { date: '2025-11-15', spotsLeft: 14 },
      { date: '2025-12-20', spotsLeft: 8 },
      { date: '2026-02-10', spotsLeft: 14 }
    ],
    nextDeparture: '2025-08-20',
    spotsLeft: 10,
    maxGroupSize: 14
  },
  {
    id: 'greece-group-sailing',
    title: 'Greek Sailing Adventure',
    destination: 'santorini',
    image: 'https://images.unsplash.com/photo-1586500038052-4e5e59fe3dd5?w=800',
    themes: ['adventure', 'friends', 'solo'],
    duration: 8,
    price: 232317,
    originalPrice: 265517,
    rating: 4.9,
    reviews: 51,
    description: 'Sail the Greek islands with a crew of adventurous travelers.',
    highlights: ['Island Hopping', 'Swimming Stops', 'Local Tavernas', 'Stunning Sunsets'],
    included: ['Yacht Accommodation', 'Captain & Crew', 'Some Meals'],
    departureDates: [
      { date: '2025-07-28', spotsLeft: 4 },
      { date: '2025-08-18', spotsLeft: 10 },
      { date: '2025-09-08', spotsLeft: 12 },
      { date: '2026-05-15', spotsLeft: 12 },
      { date: '2026-06-20', spotsLeft: 12 }
    ],
    nextDeparture: '2025-07-28',
    spotsLeft: 4,
    maxGroupSize: 12
  }
];

export const blogs = [
  {
    id: 'bali-hidden-gems',
    title: '10 Hidden Gems in Bali You Must Visit',
    excerpt: 'Beyond the tourist crowds, discover Bali\'s secret waterfalls, temples, and local spots.',
    content: 'Bali is more than just Kuta Beach and Ubud rice terraces. Our travel experts have uncovered the most enchanting hidden spots that most tourists never see...',
    image: 'https://images.unsplash.com/photo-1555400038-63f5ba517a47?w=800',
    author: 'Sarah Chen',
    authorImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100',
    date: '2025-07-10',
    readTime: 8,
    category: 'Destination Guide',
    tags: ['Bali', 'Indonesia', 'Hidden Gems']
  },
  {
    id: 'packing-tips-minimalist',
    title: 'The Ultimate Minimalist Packing Guide',
    excerpt: 'Travel lighter, travel better. Learn how to pack for any trip with just a carry-on.',
    content: 'Years of traveling have taught us one truth: less is more. This comprehensive guide will show you how to pack efficiently...',
    image: 'https://images.unsplash.com/photo-1553913861-c0a9e3e5e5e7?w=800',
    author: 'Marcus Rodriguez',
    authorImage: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100',
    date: '2025-07-05',
    readTime: 6,
    category: 'Travel Tips',
    tags: ['Packing', 'Tips', 'Minimalist']
  },
  {
    id: 'japan-cherry-blossom',
    title: 'Cherry Blossom Season: A Complete Japan Guide',
    excerpt: 'Plan your perfect hanami experience with our comprehensive cherry blossom guide.',
    content: 'Cherry blossom season in Japan is a magical time that draws visitors from around the world...',
    image: 'https://images.unsplash.com/photo-1522383225653-ed111181a951?w=800',
    author: 'Yuki Tanaka',
    authorImage: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100',
    date: '2025-06-28',
    readTime: 10,
    category: 'Seasonal Travel',
    tags: ['Japan', 'Cherry Blossom', 'Spring']
  },
  {
    id: 'solo-travel-safety',
    title: 'Solo Travel: Safety Tips for First-Timers',
    excerpt: 'Embark on your solo adventure with confidence using these essential safety tips.',
    content: 'Solo travel can be one of the most rewarding experiences of your life...',
    image: 'https://images.unsplash.com/photo-1501555088652-021faa106b9b?w=800',
    author: 'Emma Wilson',
    authorImage: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100',
    date: '2025-06-20',
    readTime: 7,
    category: 'Solo Travel',
    tags: ['Solo', 'Safety', 'Tips']
  },
  {
    id: 'sustainable-travel',
    title: 'How to Travel Sustainably in 2025',
    excerpt: 'Make a positive impact with eco-friendly travel choices.',
    content: 'Sustainable travel is no longer just a trend—it\'s a responsibility...',
    image: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=800',
    author: 'David Green',
    authorImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100',
    date: '2025-06-15',
    readTime: 9,
    category: 'Eco Travel',
    tags: ['Sustainable', 'Eco-friendly', 'Green Travel']
  },
  {
    id: 'food-tours-europe',
    title: 'Best Food Tours in Europe for Foodies',
    excerpt: 'Taste your way through Europe\'s culinary capitals.',
    content: 'From pasta-making in Bologna to pintxos crawls in San Sebastian...',
    image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800',
    author: 'Isabella Romano',
    authorImage: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=100',
    date: '2025-06-08',
    readTime: 8,
    category: 'Food & Culture',
    tags: ['Food', 'Europe', 'Culinary']
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Jennifer & Michael',
    location: 'New York, USA',
    image: 'https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?w=100',
    trip: 'Maldives Honeymoon',
    rating: 5,
    text: 'Absolutely magical! Funstay made our honeymoon dreams come true. Every detail was perfect.'
  },
  {
    id: 2,
    name: 'Robert Thompson',
    location: 'London, UK',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100',
    trip: 'Japan Cultural Tour',
    rating: 5,
    text: 'The attention to cultural experiences was outstanding. Truly immersive and unforgettable.'
  },
  {
    id: 3,
    name: 'The Martinez Family',
    location: 'Toronto, Canada',
    image: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=100',
    trip: 'Costa Rica Family Adventure',
    rating: 5,
    text: 'Best family vacation ever! The kids are still talking about the wildlife and zip-lining.'
  },
  {
    id: 4,
    name: 'Sophia Lee',
    location: 'Singapore',
    image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=100',
    trip: 'Solo Bali Retreat',
    rating: 5,
    text: 'Traveling solo was daunting, but Funstay made me feel safe and cared for throughout.'
  }
];

export const teamMembers = [
  {
    name: 'Alexandra Rivera',
    role: 'Founder & CEO',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400',
    bio: 'With 15+ years in luxury travel, Alex founded Funstay to make extraordinary journeys accessible.'
  },
  {
    name: 'James Chen',
    role: 'Head of Experiences',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400',
    bio: 'James has visited 80+ countries and curates our most unique travel experiences.'
  },
  {
    name: 'Priya Sharma',
    role: 'Customer Success Lead',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400',
    bio: 'Priya ensures every traveler receives personalized attention and seamless support.'
  },
  {
    name: 'Marco Rossi',
    role: 'Europe Specialist',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
    bio: 'Born in Rome, Marco brings insider knowledge to all European destinations.'
  }
];

export const stats = [
  { value: '50K+', label: 'Happy Travelers' },
  { value: '120+', label: 'Destinations' },
  { value: '98%', label: 'Satisfaction Rate' },
  { value: '24/7', label: 'Support' }
];

export const budgetRanges = [
  { id: 'budget', label: 'Budget', min: 0, max: 2000 },
  { id: 'mid', label: 'Mid-Range', min: 2000, max: 4000 },
  { id: 'luxury', label: 'Luxury', min: 4000, max: 8000 },
  { id: 'ultra', label: 'Ultra Luxury', min: 8000, max: 999999 }
];

export const durationRanges = [
  { id: 'short', label: '1-5 Days', min: 1, max: 5 },
  { id: 'week', label: '6-8 Days', min: 6, max: 8 },
  { id: 'long', label: '9-14 Days', min: 9, max: 14 },
  { id: 'extended', label: '15+ Days', min: 15, max: 999 }
];
